import { useSelector } from 'react-redux'
import { getInternalIdentity } from 'src/selectors/internalAuth'

/**
 * Whether there is a usable admin session: a WorkOS user whose internal identity the API has
 * confirmed. Pages use it to hold their fetch effects until a request can actually carry a token,
 * and as an effect dependency so they fetch once the session arrives.
 */
export const useAuthSession = () => {
  const identity = useSelector(getInternalIdentity)

  return {
    isAuthenticated: identity !== null,
  }
}
